import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(date) {
  if (!date) return '-';
  return new Date(date).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatNumber(num) {
  if (num === null || num === undefined) return '-';
  return new Intl.NumberFormat('en-GB').format(num);
}

export function formatCurrency(amount, currency = 'GBP') {
  if (amount === null || amount === undefined) return '-';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
  }).format(amount);
}

export function formatPercentage(value, decimals = 2) {
  if (value === null || value === undefined) return '-';
  return `${(value * 100).toFixed(decimals)}%`;
}

export function truncate(str, length = 50) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

export function getStatusColor(status) {
  const colors = {
    published: 'success',
    approved: 'success',
    review: 'warning',
    refused: 'error',
    draft: 'neutral',
    pending: 'warning',
    generating: 'info',
    sent: 'success',
    failed: 'error',
    skipped: 'neutral',
    delivered: 'success',
    bounced: 'error',
  };
  return colors[status?.toLowerCase()] || 'neutral';
}

export function getChannelLabel(channel) {
  const labels = {
    google_ads: 'Google Ads',
    linkedin_ads: 'LinkedIn Ads',
    meta_ads: 'Meta Ads',
    organic: 'Organic',
    email: 'Email',
    sms: 'SMS',
  };
  return labels[channel] || channel;
}

export function getRecordTypeLabel(type) {
  const labels = {
    organisation: 'Organisation',
    person: 'Person',
    property: 'Property',
    event: 'Event',
    relationship: 'Relationship',
    document: 'Document',
  };
  return labels[type] || type;
}

export function getStoryTypeLabel(type) {
  const labels = {
    sector_summary: 'Sector Summary',
    company_announcement: 'Company Announcement',
    regulatory_action: 'Regulatory Action',
    procurement_award: 'Procurement Award',
    insolvency_notice: 'Insolvency Notice',
    director_appointment: 'Director Appointment',
    planning_decision: 'Planning Decision',
    government_policy: 'Government Policy',
    research_breakdown: 'Research Breakdown',
    industry_digest: 'Industry Digest',
  };
  return labels[type] || type;
}

export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
